/*eslint-disable*/
import * as util from 'lib/utility';
import _ from 'lodash';
import { fetch, post, whoAmI, fetchPolicyInfo } from 'lib/network/webapi';
import insDataStub from '../../lib/inspectionsData';
import _debug from 'debug';

export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_CAMPAIGN_DATA = 'FETCH_CAMPAIGN_DATA';
export const FETCH_CAMPAIGN_DATA_SUCCESS = 'FETCH_CAMPAIGN_DATA_SUCCESS';
export const FETCH_CAMPAIGN_DATA_FAIL = 'FETCH_CAMPAIGN_DATA_FAIL';
export const FETCH_POLICY_DATA = 'FETCH_POLICY_DATA';
export const FETCH_POLICY_DATA_SUCCESS = 'FETCH_POLICY_DATA_SUCCESS';
export const FETCH_POLICY_DATA_FAIL = 'FETCH_POLICY_DATA_FAIL';
export const FETCH_INSPECTION_DATA = 'FETCH_INSPECTION_DATA';
export const FETCH_INSPECTION_DATA_SUCCESS = 'FETCH_INSPECTION_DATA_SUCCESS';
export const FETCH_INSPECTION_DATA_FAIL = 'FETCH_INSPECTION_DATA_FAIL';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAIL = 'FETCH_DATA_FAIL';
export const SET_OWNER_ID = 'SET_OWNER_ID';
export const ASSIGNED_ROW_COUNT = 'ASSIGNED_ROW_COUNT';
export const UNASSIGNED_ROW_COUNT = 'UNASSIGNED_ROW_COUNT';
export const UNASSIGNED_START_END_INDEX = 'UNASSIGNED_START_END_INDEX';
export const ASSIGNED_START_END_INDEX = 'ASSIGNED_START_END_INDEX';
export const ACTIVE_INDEX = 'ACTIVE_INDEX';
export const FETCH_AGENT_DATA = 'FETCH_AGENT_DATA';
export const FETCH_AGENT_DATA_SUCCESS = 'FETCH_AGENT_DATA_SUCCESS';
export const FETCH_AGENT_DATA_FAIL = 'FETCH_AGENT_DATA_FAIL';
export const ADD = 'ADD';
export const ADD_ALL = 'ADD_ALL';
export const REMOVE = 'REMOVE';
export const REMOVE_ALL = 'REMOVE_ALL';
export const FILTER_EXPAND = 'FILTER_EXPAND';
export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const SET_FILTER_VALUE_SUCCESS = 'SET_FILTER_VALUE_SUCCESS';
export const SET_FILTER_VALUE_FAIL = 'SET_FILTER_VALUE_FAIL';
export const APPLY_FILTER = 'APPLY_FILTER';
export const APPLY_FILTER_INDEX = 'APPLY_FILTER_INDEX';
export const REVERSE_FILTER = 'REVERSE_FILTER';
export const CLEAR_ALL = 'CLEAR_ALL';
export const CLEAR_ALL_INDEX = 'CLEAR_ALL_INDEX';
export const FETCH_OPTION_LEAD_TYPE = 'FETCH_OPTION_LEAD_TYPE';
export const FETCH_OPTION_LEAD_TYPE_SUCCESS = 'FETCH_OPTION_LEAD_TYPE_SUCCESS';
export const FETCH_OPTION_LEAD_TYPE_FAIL = 'FETCH_OPTION_LEAD_TYPE_FAIL';
export const FETCH_OPTION_LANG_INDICATOR = 'FETCH_OPTION_LANG_INDICATOR';
export const FETCH_OPTION_LANG_INDICATOR_SUCCESS = 'FETCH_OPTION_LANG_INDICATOR_SUCCESS';
export const FETCH_OPTION_LANG_INDICATOR_FAIL = 'FETCH_OPTION_LANG_INDICATOR_FAIL';
export const AGENT_LIST = 'AGENT_LIST';
export const AGENT_LIST_SUCCESS = 'AGENT_LIST_SUCCESS';
export const AGENT_LIST_FAIL = 'AGENT_LIST_FAIL';
export const AGENT_PRIMARY_LIST = 'AGENT_PRIMARY_LIST';
export const AGENT_PRIMARY_LIST_SUCCESS = 'AGENT_PRIMARY_LIST_SUCCESS';
export const AGENT_PRIMARY_LIST_FAIL = 'AGENT_PRIMARY_LIST_FAIL';
export const CONFIRM_ASSIGN = 'CONFIRM_ASSIGN';
export const APPLY_ASSIGNMENT = 'APPLY_ASSIGNMENT';
export const UPDATE_RECORD = 'UPDATE_RECORD';
export const UPDATE_RECORD_SUCCESS = 'UPDATE_RECORD_SUCCESS';
export const UPDATE_RECORD_FAIL = 'UPDATE_RECORD_FAIL';
export const FETCH_OWNER_ID = 'FETCH_OWNER_ID';
export const FETCH_OWNER_ID_SUCCESS = 'FETCH_OWNER_ID_SUCCESS';
export const FETCH_OWNER_ID_FAIL = 'FETCH_OWNER_ID_FAIL';
export const FETCH_OPTION_DISPOSITION = 'FETCH_OPTION_DISPOSITION';
export const FETCH_OPTION_DISPOSITION_SUCCESS = 'FETCH_OPTION_DISPOSITION_SUCCESS';
export const FETCH_OPTION_DISPOSITION_FAIL = 'FETCH_OPTION_DISPOSITION_FAIL';
export const FETCH_CALL_TYPE = 'FETCH_CALL_TYPE';
export const FETCH_CALL_TYPE_SUCCESS = 'FETCH_CALL_TYPE';
export const FETCH_CALL_TYPE_FAIL = 'FETCH_CALL_TYPE_FAIL';
export const APPLY_SEARCH_NAME = 'APPLY_SEARCH_NAME';
export const APPLY_SEARCH_STREET = 'APPLY_SEARCH_STREET';
export const APPLY_SEARCH_WRITING_AGENT = 'APPLY_SEARCH_WRITING_AGENT';
export const SHOW_LOADING_SCREEN = 'SHOW_LOADING_SCREEN';
export const RESET = 'RESET';
export const UPDATE_NAME_SEARCH = 'UPDATE_NAME_SEARCH';
export const UPDATE_STREET_ADDRESS_SEARCH = 'UPDATE_STREET_ADDRESS_SEARCH';
export const UPDATE_WRITING_AGENT_SEARCH = 'UPDATE_WRITING_AGENT_SEARCH';
export const SHOW_LEADS_DATA = 'SHOW_LEADS_DATA';
export const SHOW_INSPECTIONS_DATA = 'SHOW_INSPECTIONS_DATA';
export const UPDATE_INSPECTIONS_DATA = 'UPDATE_INSPECTIONS_DATA';
export const UPDATE_INSPECTION = 'UPDATE_INSPECTION';
export const UPDATE_INSPECTION_SUCCESS = 'UPDATE_INSPECTION_SUCCESS';
export const UPDATE_INSPECTION_FAIL = 'UPDATE_INSPECTION_FAIL';
export const UPDATE_INSPECTED_START_END_INDEX = 'UPDATE_INSPECTED_START_END_INDEX';
export const INSPECTION_FILTER_EXPAND = 'INSPECTION_FILTER_EXPAND';
export const FETCH_SYSTEM_SETTINGS_DATA = 'FETCH_SYSTEM_SETTINGS_DATA';
export const FETCH_SYSTEM_SETTINGS_DATA_FAIL = 'FETCH_SYSTEM_SETTINGS_DATA_FAIL';
export const FETCH_SYSTEM_SETTINGS_DATA_SUCCESS = 'FETCH_SYSTEM_SETTINGS_DATA_SUCCESS';
export const UPDATE_LANG = 'UPDATE_LANG';
export const UPDATE_ACTIVE_PAGE = 'UPDATE_ACTIVE_PAGE';

const debug = _debug('app:assigner');

const initialState = {
  isLoading: false,
  currentLanguage: 'en',
  showAssignmentLoader: false,
  leadsData: [],
  inspectionsData: [],
  systemsettings: [],
  odataNextLink: 'null',
  tabOneLeadsData: [],
  tabTwoLeadsData: [],
  tabThreeInsData: [],
  tabOneSearchData: [],
  tabTwoSearchData: [],
  tabThreeSearchData: [],
  primaryAndSecondaryRecordMapping: {},
  error: '',
  unassigned: {
    startIndex: 0,
    endIndex: 50
  },
  inspected: {
    startIndex: 0,
    endIndex: 50
  },
  assigned: {
    startIndex: 0,
    endIndex: 50
  },
  activeIndex: 0,
  impersonation: false,
  selectedRecords: [],
  filterExpanded: false,
  inspectionFilterExpanded: false,
  campaignData: [],
  policyData: {},
  inspectionsData: [],
  campodataNextLink: 'null',
  inspectionodataNextLink: 'null',
  optionSet: {
    leadType: [],
    languageIndicator: [],
    disposition: [],
    callType: []
  },
  filter: {
    0: {
      state: [], /* These filter names should be in sync with the datakey defined in utility */
      county: [],
      city: [],
      zip: [],
      language: [],
      leadType: [],
      lastAssigned: [],
      lastSelling: [],
      streetAddress: [],
      campaign: [],
      lineOneManager: [],
      activeLastSellingAgentName: [],
      isOrphaned: [],
      tier: [],
      campaignPurpose: []
    },
    1: {
      state: [],
      county: [],
      city: [],
      zip: [],
      language: [],
      leadType: [],
      assignedTo: [],
      disposition: [],
      streetAddress: [],
      campaign: [],
      lineOneManager: [],
      activeLastSellingAgentName: [],
      isOrphaned: [],
      assignmentSource: [],
      tier: [],
      campaignPurpose: []
    },
    2: {
      cica_writingagent: [], /* These filter names should be in sync with the datakey defined in utility */
      product: [],
      division: [],
      cica_appdate: []
    }
  },
  agentData: {
    list: [],
    odataNextLink: 'null'
  },
  agentPrimaryData: {
    list: [],
    odataNextLink: 'null'
  },
  marketDirectorList: {
    data: []
  },
  ownerId: '',
  ownerGuid: '',
  newOwnerId: '',
  newownerGuid: '',
  loginName: '',
  isMarketOpen: '',
  marketCode: '',
  originalOwnerGuid: '',
  searchValueNameTabOne: '',
  searchStreetAddressTabOne: '',
  searchValueNameTabTwo: '',
  searchStreetAddressTabTwo: '',
  searchWritingAgentTabThree: '',
  searchValueNameTabThree: '',
  inspectionsOptionSet: {
    customerExperience: [
      { value: 1, label: '1 Poor' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: '5 Excellent' }
    ],
    noContactData: [
      { value: 1, label: 'Left Message' },
      { value: 2, label: 'Bad Phone Number' },
      { value: 3, label: 'Inspector Present at Time of Sale' },
      { value: 4, label: 'Inspection Not Required' },
      { value: 5, label: 'Policy Cancelled' }
    ],
    trainingOpportunityData : [
      { value: 1, label: 'None' },
      { value: 2, label: 'Affordability' },
      { value: 5, label: 'Billing Process' },
      { value: 7, label: 'Friend/Family Business' },
      { value: 4, label: 'Needs Based Selling' },
      { value: 3, label: 'Product Knowledge' },
      { value: 6, label: 'Payment Mode' }
    ]
  },
  activePage: false,
  moreRecords: false,
  pageNumber: 0,
  lastModifiedOn: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET:
      return initialState;

    case FETCH_OWNER_ID_SUCCESS: {
      return {
        ...state,
        ownerId: action.result.data.data.result[0].internalemailaddress,
        ownerGuid: action.result.data.data.result[0].id,
        originalOwnerGuid: action.result.data.data.result[0].id 
      }
    };
    case SET_OWNER_ID: {
      return {
        ...state,
        newOwnerId: action.payload.value,
        newownerGuid: action.payload.ownerGuid1,
        ownerId: action.payload.id,
        ownerGuid: action.payload.ownerGuid,
        loginName: action.payload.name,
        isMarketOpen: action.payload.marketOpen,
        marketCode: action.payload.marketCode,
        secondMarketValues: action.payload.secondMarketValues,
        impersonation: true
      }
    }
    case FETCH_AGENT_DATA_SUCCESS: {
      return {
        ...state,
          marketDirectorList: {
            data: [...action.result.data.data.result]
          }
      };
    }
    case CONFIRM_ASSIGN: {
      const newList = _.cloneDeep(state.leadsData);
      const newpriSecMappingList = _.cloneDeep(state.primaryAndSecondaryRecordMapping);
      for (const x of action.payload) {
        const index = _.findIndex(newList, ['id', x.id]);
        if (index > -1) {
          newList[index] = x;
        }
        const priSecMappingIndex = _.findIndex(newpriSecMappingList[x.householdIndicator], ['id', x.id]);
        if (priSecMappingIndex > -1) {
          newpriSecMappingList[x.householdIndicator][priSecMappingIndex] = x;
        }
      }
      return {
        ...state,
        leadsData: newList,
        primaryAndSecondaryRecordMapping: newpriSecMappingList
      };
    }

    case FETCH_CAMPAIGN_DATA :
      return {
        ...state
      };
    case FETCH_POLICY_DATA:
      return {
        ...state
      };
    case FETCH_CAMPAIGN_DATA_SUCCESS :
      return {
       ...state,
       campaignData: [...state.campaignData, ...action.result.data.data.result],
       campodataNextLink: action.result.data['@odata.nextLink'] ? action.result.data['@odata.nextLink'] : 'null'
      };
    case FETCH_POLICY_DATA_SUCCESS :
      return {
        ...state,
        policyData: action.result.data.data.result,
        policyDataodataNextLink: action.result.data['@odata.nextLink'] ? action.result.data['@odata.nextLink'] : 'null'
      };

    case FETCH_CAMPAIGN_DATA_FAIL :
      return {
        ...state,
        error: action.error
      };
    case FETCH_POLICY_DATA_FAIL :
      return {
        ...state,
        error: action.error
      };
    case FETCH_INSPECTION_DATA :
      return {
        ...state
      };

    case FETCH_INSPECTION_DATA_SUCCESS :
      return {
       ...state,
       inspectionsData: [...state.inspectionsData, ...action.result.data.data.result],
       inspectodataNextLink: action.result.data['@odata.nextLink'] ? action.result.data['@odata.nextLink'] : 'null'
      };

    case FETCH_INSPECTION_DATA_FAIL :
      return {
        ...state,
        error: action.error
      };
    case FETCH_SYSTEM_SETTINGS_DATA :
      return {
        ...state
      };

    case FETCH_SYSTEM_SETTINGS_DATA_SUCCESS :
      return {
       ...state,
       systemsettings: [...state.systemsettings, ...action.result.data.data.result]
      };

    case FETCH_SYSTEM_SETTINGS_DATA_FAIL :
      return {
        ...state,
        error: action.error
      };
    case UPDATE_RECORD_SUCCESS:
      return {
        ...state
      };

    case UPDATE_RECORD_FAIL:
      return {
        ...state
      };

    case APPLY_ASSIGNMENT: {
      const leadData = state.leadsData;
      const dataUnassigned = leadData.filter(obj => obj.status === 'Unassigned' && !obj.isSecondary);
      const dataAssigned = leadData.filter(obj => obj.status === 'Assigned' && !obj.isSecondary);
      return {
        ...state,
        tabOneLeadsData: dataUnassigned,
        tabTwoLeadsData: dataAssigned
      };
    }
    case AGENT_LIST_SUCCESS: {
      return {
        ...state,
        agentData: {
          list: [...state.agentData.list, ...action.result.data.data.result],
          odataNextLink: action.result.data['@odata.nextLink'] ? action.result.data['@odata.nextLink'] : 'null',
        }
      };
    }
    case AGENT_PRIMARY_LIST_SUCCESS: {
      return {
        ...state,
        agentPrimaryData: {
          list: [...state.agentPrimaryData.list, ...action.result.data.data.result],
          odataNextLink: action.result.data['@odata.nextLink'] ? action.result.data['@odata.nextLink'] : 'null',
        }
      };
    }
    case FETCH_OPTION_DISPOSITION_SUCCESS: {
      const Cdisposition = util.fetchPickListObject(action.result.data.data.result);
      return {
        ...state,
        optionSet: {
          ...state.optionSet,
          disposition: util.fetchPickListObject(action.result.data.data.result)
        }
      };
    }
    case FETCH_OPTION_LEAD_TYPE:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_OPTION_LEAD_TYPE_SUCCESS: {
      return {
        ...state,
        optionSet: {
          ...state.optionSet,
          leadType: util.fetchPickListObject(action.result.data.data.result)
        }
      };
    }
    case FETCH_CALL_TYPE:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_CALL_TYPE_SUCCESS: {
      return {
        ...state,
        optionSet: {
          ...state.optionSet,
          callType: util.fetchPickListObject(action.result.data.data.result)
        }
      };
    }
    case FETCH_OPTION_LANG_INDICATOR_SUCCESS: {
      return {
        ...state,
        optionSet: {
          ...state.optionSet,
          languageIndicator: util.fetchPickListObject(action.result.data.data.result)
        }
      };
    }
    case SET_FILTER_VALUE_SUCCESS :
      if (state.activeIndex === 0) {
        return {
          ...state,
          filter: {
            ...state.filter,
            0: Object.assign({}, state.filter[state.activeIndex], action.result)
          }
        };
      } else if (state.activeIndex === 2) {
        return {
          ...state,
          filter: {
            ...state.filter,
            2: Object.assign({}, state.filter[state.activeIndex], action.result)
          }
        };
      }
      return {
        ...state,
        filter: {
          ...state.filter,
          1: Object.assign({}, state.filter[state.activeIndex], action.result)
        }
      };
    case CLEAR_ALL: {
      if (state.activeIndex === 0) {
        return {
          ...state,
          filter: {
            ...state.filter,
            0: action.payload[state.activeIndex]
          }
        };
      } else if (state.activeIndex === 2) {
        return {
          ...state,
          filter: {
            ...state.filter,
            2: action.payload[state.activeIndex]
          }
        };
      }
      return {
        ...state,
        filter: {
          ...state.filter,
          1: action.payload[state.activeIndex]
        }
      };
    }
    case CLEAR_ALL_INDEX: {
      return {
        ...state,
        filter: {
          ...state.filter,
          2: action.payload
        }
      };
    }
    case SET_FILTER_VALUE_FAIL :
      return {
        ...state,
        error: action.error
      };
    case APPLY_FILTER : {
      const filters = Object.keys(state.filter[state.activeIndex]);
      let inspectionsData = state.inspectionsData;
      let data = state.leadsData;
      if (state.activeIndex === 0) {
        data = data.filter(obj => obj.status === 'Unassigned' && !obj.isSecondary);
        filters.forEach((item) => {
          if (state.filter[state.activeIndex][item].length > 0) {
            data = data.filter(
              (obj) => {
                if (item === 'campaign') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);
                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                if (item === 'campaignPurpose') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);
                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                if (item === 'zip') {
                  return _.includes(state.filter[state.activeIndex][item], obj[item].substr(0, 5))
                }
                return _.includes(state.filter[state.activeIndex][item], obj[item])
              }
            );
          }
        });
        return {
          ...state,
          tabOneLeadsData: data,
          tabOneSearchData: data
        };
      } else if (state.activeIndex === 2) {
          inspectionsData = inspectionsData.filter(obj => obj);
          filters.forEach((item) => {
            if (state.filter[state.activeIndex][item].length > 0) {
              inspectionsData = inspectionsData.filter(
                (obj) => {
                  return _.includes(state.filter[state.activeIndex][item], obj[item])
                }
              );
            }
          });
          return {
            ...state,
            tabThreeInsData: inspectionsData,
            tabThreeSearchData: inspectionsData
          };
      }
      data = data.filter(obj => obj.status === 'Assigned' && !obj.isSecondary);
      filters.forEach((item) => {
        if (state.filter[state.activeIndex][item].length > 0) {
          data = data.filter(
            (obj) => {
              if (item === 'campaign') {
                const dataArray = state.filter[state.activeIndex][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              if (item === 'campaignPurpose') {
                const dataArray = state.filter[state.activeIndex][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              if (item === 'zip') {
                return _.includes(state.filter[state.activeIndex][item], obj[item].substr(0, 5))
              }
              return _.includes(state.filter[state.activeIndex][item], obj[item])
            }
          );
        }
      });
      return {
        ...state,
        tabTwoLeadsData: data,
        tabTwoSearchData: data
      };
    }

    case APPLY_FILTER_INDEX : {
      const filters = Object.keys(state.filter[action.payload]);
      let insData = state.inspectionsData;
      insData = insData.filter(obj => obj);
      filters.forEach((item) => {
        if (state.filter[action.payload][item].length > 0) {
          insData = insData.filter(
            (obj) => {
              return _.includes(state.filter[action.payload][item], obj[item])
            }
          );
        }
      });
      return {
        ...state,
        tabThreeInsData: insData,
        tabThreeSearchData: insData
      };
    }

    case REVERSE_FILTER : {
      const filters = Object.keys(state.filter['0']);
      let data = state.leadsData;
      let data2 = state.leadsData;
      data = data.filter(obj => obj.status === 'Unassigned' && !obj.isSecondary);
      filters.forEach((item) => {
        if (state.filter['0'][item] && state.filter['0'][item].length > 0) {
          data = data.filter(
            (obj) => {
              if (item === 'campaign') {
                const dataArray = state.filter['0'][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              return _.includes(state.filter['0'][item], obj[item])
            }
          );
        }
      });

      data2 = data2.filter(obj => obj.status === 'Assigned' && !obj.isSecondary);
      const filterz = Object.keys(state.filter['1']);
      filterz.forEach((item) => {
        if (state.filter['1'][item] && state.filter['1'][item].length > 0) {
          data2 = data2.filter(
            (obj) => {
              if (item === 'campaign') {
                const dataArray = state.filter['1'][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              return _.includes(state.filter['1'][item], obj[item])
            }
          );
        }
      });
      return {
        ...state,
        tabOneLeadsData: data,
        tabOneSearchData: data,
        tabTwoLeadsData: data2,
        tabTwoSearchData: data2
      };
    }

    case APPLY_SEARCH_NAME : {
      const data = action.payload;
      if (state.activeIndex === 0) {
        return {
          ...state,
          tabOneLeadsData: data
        };
      }

      if (state.activeIndex === 2) {
        return {
          ...state,
          tabThreeInsData: data
        };
      }

      return {
        ...state,
        tabTwoLeadsData: data
      };
    }

    case APPLY_SEARCH_STREET : {
      const data = action.payload;
      if (state.activeIndex === 0) {
        return {
          ...state,
          tabOneLeadsData: data
        };
      }

      return {
        ...state,
        tabTwoLeadsData: data
      };
    }

    case APPLY_SEARCH_WRITING_AGENT : {
      const data = action.payload;
      return {
        ...state,
        tabThreeInsData: data
      };
    }

    case FILTER_EXPAND :
      return {
        ...state,
        filterExpanded: action.payload
      };

    case INSPECTION_FILTER_EXPAND :
      return {
        ...state,
        inspectionFilterExpanded: action.payload
      };

    case SHOW_LEADS_DATA : {
      const rawLeadsData = state.rawLeadsData;
      console.log('rawLeadsData==>', rawLeadsData);
      let formattedData = [];
      let list = [];
      rawLeadsData.forEach((current) => {
        if (current && current.value) {
          formattedData = [...formattedData, util.formatDataForTableView(
            current.value,
            state.optionSet,
            state.ownerId,
            state.ownerGuid,
            state.primaryAndSecondaryRecordMapping,
            state.campaignData,
            state.inspectionsData,
            state.agentData && state.agentData.list
          )]
        }
      });

      let allFormattedData = [];
      let allPrimaryAndSecondaryRecordMapping = {};

      formattedData.forEach((currentFormattedData) => {
        allFormattedData.push(currentFormattedData.data);
        allPrimaryAndSecondaryRecordMapping = { ...allPrimaryAndSecondaryRecordMapping, ...currentFormattedData.primaryAndSecondaryRecordMapping };
      });

      const newAllFormattedData = _.flatten(_.map(allFormattedData, _.values));
      const finallist = newAllFormattedData.map((rec) => {
        const record = rec;
        Object.keys(allPrimaryAndSecondaryRecordMapping).forEach((key) => {
          if (key && key !== null && record.personId === key) {
            allPrimaryAndSecondaryRecordMapping[key].forEach((data) => {
              if (data.campaign !== null) {
                if (_.isArray(record.campaign)) {
                  record.campaign = [...record.campaign, ...data.campaign];
                } else {
                  record.campaign = data.campaign;
                }
              }
            });
          }
        });
        return record;
      });
      return {
        ...state,
        isLoading: false,
        leadsData: finallist,
        primaryAndSecondaryRecordMapping: allPrimaryAndSecondaryRecordMapping,
        tabOneLeadsData: [...state.tabOneLeadsData, ...newAllFormattedData.filter(obj => obj.status === 'Unassigned' && !obj.isSecondary)],
        tabOneSearchData: [...state.tabOneSearchData, ...newAllFormattedData.filter(obj => obj.status === 'Unassigned' && !obj.isSecondary)],
        tabTwoLeadsData: [...state.tabTwoLeadsData, ...newAllFormattedData.filter(obj => obj.status === 'Assigned' && !obj.isSecondary)],
        tabTwoSearchData: [...state.tabTwoSearchData, ...newAllFormattedData.filter(obj => obj.status === 'Assigned' && !obj.isSecondary)]
      };
    }
    case SHOW_INSPECTIONS_DATA : {
      const inspectionsData = state.inspectionsData;
      let formattedData = [];
      const newFormattedInspectionData = util.formatInspDataForTableView(inspectionsData);
      if (inspectionsData) {
        formattedData = [...formattedData, ...newFormattedInspectionData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired))]
      }
      return {
        ...state,
        inspectionsData: formattedData && formattedData.length > 0 && formattedData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired)) || [],
        tabThreeInsData: formattedData && formattedData.length > 0 && formattedData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired)) || [],
        tabThreeSearchData: formattedData && formattedData.length > 0 && formattedData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired)) || []
      };
    }
    case UPDATE_INSPECTIONS_DATA :
      const inspectionsData = state.inspectionsData; // this is all data
      const tabThreeInsData = state.tabThreeInsData; //this is filtered data
      const tabThreeSearchData = state.tabThreeSearchData; // this is search data

      const foundOriginalIndex = inspectionsData.findIndex(data => data.id === action.payload.id);
      inspectionsData[foundOriginalIndex] = action.payload;

      const foundFilterIndex = tabThreeInsData.findIndex(data => data.id === action.payload.id);
      tabThreeInsData[foundFilterIndex] = action.payload;

      const foundSearchIndex = tabThreeSearchData.findIndex(data => data.id === action.payload.id);
      tabThreeSearchData[foundSearchIndex] = action.payload;

      return {
        ...state,
        inspectionsData: inspectionsData && inspectionsData.length > 0 && inspectionsData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired)),
        tabThreeInsData: tabThreeInsData && tabThreeInsData.length > 0 && tabThreeInsData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired)),
        tabThreeSearchData: tabThreeSearchData && tabThreeSearchData.length > 0 && tabThreeSearchData.filter(obj => (!obj.cica_issubmitted && !obj.cica_isexpired))
      };
    case FETCH_DATA_SUCCESS : {
      let myList = state.rawLeadsData ? state.rawLeadsData : [];
      if (action.result) {
        myList = [...myList, {
          value: action.result.data.data.result,
          optionSet: state.optionSet,
          ownerId: state.ownerId,
          primaryAndSecondaryRecordMapping: state.primaryAndSecondaryRecordMapping,
          campaignData: state.campaignData,
          inspectionsData: state.inspectionsData
        }];
      }
      const list = [];
      return {
        ...state,
        odataNextLink: action.result && action.result.data['@odata.nextLink'] ? action.result.data['@odata.nextLink'] : 'complete',
        leadsData: list,
        rawLeadsData: myList,
        moreRecords: action.result.data.data.paging.moreRecords,
        pageNumber: state.pageNumber + 1
      };
    }
    case FETCH_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case UNASSIGNED_START_END_INDEX :
      return Object.assign({}, state, {
        unassigned: {
          ...state.unassigned,
          startIndex: action.payload.startIndex,
          endIndex: action.payload.endIndex
        }
      });
    case UPDATE_INSPECTED_START_END_INDEX :
      return Object.assign({}, state, {
        inspected: {
          ...state.inspected,
          startIndex: action.payload.startIndex,
          endIndex: action.payload.endIndex
        }
      });

    case ASSIGNED_START_END_INDEX :
      return Object.assign({}, state, {
        assigned: {
          ...state.assigned,
          startIndex: action.payload.startIndex,
          endIndex: action.payload.endIndex
        }
      });
    case ACTIVE_INDEX:
      return {
        ...state,
        activeIndex: action.payload
      };
    case ADD:
      return {
        ...state,
        selectedRecords: [...state.selectedRecords, action.payload]
      };
    case ADD_ALL: {
      const uniqueList = (state.selectedRecords.length > 0) ?
        state.selectedRecords.filter((record) => {
          // Here we are doing a diff between the two arrays to remove
          // the duplicates, similar to below REMOVE_ALL action
          // Once the duplicates are removed we merge the uniqueList and payload
          const checkId = obj => obj.id === record.id;
          return action.payload.findIndex(checkId) === -1;
        }) : [];
      return {
        ...state,
        selectedRecords: [...uniqueList, ...action.payload]
      };
    }
    case REMOVE:
      return {
        ...state,
        selectedRecords: state.selectedRecords.filter(obj => obj.id !== action.payload.id)
      };
    case REMOVE_ALL:
      if (action.payload) {
        return {
          ...state,
          selectedRecords: state.selectedRecords.filter((record) => {
            // Here we are doing a diff between the two arrays to remove
            // the data passed as parameter to the action.
            /*
              First we loop through each record present in the state tree using the filter.
              Then using findIndex we will determine if the record is present in the
              passed list(parameter of the REMOVE_ALL action fired) action.payload
              Now if we get the index of -1, that means the record should not be removed.
              Hence we return true to retain such record -> action.payload.findIndex(checkId) === -1
            */
            const checkId = obj => obj.id === record.id;
            return action.payload.findIndex(checkId) === -1;
          })
        };
      }
      /*
        If there is no payload, it means there was no list passed,
        Which means that the header sort was clicked and we need to remove all the
        Selected records.
      */
      return {
        ...state,
        selectedRecords: []
      };
    case SHOW_LOADING_SCREEN:
      return {
        ...state,
        showAssignmentLoader: !state.showAssignmentLoader
      };
    case UPDATE_NAME_SEARCH:
      if (action.payload.tab === 0) {
        return {
          ...state,
          searchValueNameTabOne: action.payload.parameter
        }
      }
      if (action.payload.tab === 1) {
        return {
          ...state,
          searchValueNameTabTwo: action.payload.parameter
        }
      }
      return {
        ...state,
        searchValueNameTabThree: action.payload.parameter
      }
    case UPDATE_STREET_ADDRESS_SEARCH:
      if (action.payload.tab === 0) {
        return {
          ...state,
          searchStreetAddressTabOne: action.payload.parameter
        }
      }
      return {
        ...state,
        searchStreetAddressTabTwo: action.payload.parameter
      }
    case UPDATE_WRITING_AGENT_SEARCH:
      return {
        ...state,
        searchWritingAgentTabThree: action.payload.parameter
      }
    case UPDATE_LANG:
      return {
        ...state,
        currentLanguage: action.payload
    }
    case UPDATE_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.payload
    }
    default:
      return state;
  }
}

export const fetchAgentList = (modelName, ownerId, source) => {
  const request = fetch(modelName, ownerId, source);
  return {
    types: [AGENT_LIST, AGENT_LIST_SUCCESS, AGENT_LIST_FAIL],
    promise: request
  };
};

export const fetchAgentListPrimary = (modelName, ownerId, source) => {
  const request = fetch(modelName, ownerId, source);
  return {
    types: [AGENT_PRIMARY_LIST, AGENT_PRIMARY_LIST_SUCCESS, AGENT_PRIMARY_LIST_FAIL],
    promise: request
  };
};

export const dropdownAgents = (ownerId) =>
{  const request = fetch('systemuser', ownerId, 'url');
  return {
    types: [FETCH_AGENT_DATA, FETCH_AGENT_DATA_SUCCESS, FETCH_AGENT_DATA_FAIL],
    promise: request
  };
};

export const updateOwnerid = (record, dataToUpdate, newOwnerid) => {
  const request = post(dataToUpdate, newOwnerid);
  return {
    types: [UPDATE_RECORD, UPDATE_RECORD_SUCCESS, UPDATE_RECORD_FAIL],
    promise: request
  };
};

export const updateInspectionsDisposition = (dataToUpdate, ownerId) => {
  const request = post(dataToUpdate, ownerId);
  return {
    types: [UPDATE_INSPECTION, UPDATE_INSPECTION_SUCCESS, UPDATE_INSPECTION_FAIL],
    promise: request
  };
};

export const fetchAll = (modelName, ownerId, source, pageNumber, impersonate) => {
  const request = fetch(modelName, ownerId, source, pageNumber, impersonate);
  return {
    types: [FETCH_DATA, FETCH_DATA_SUCCESS, FETCH_DATA_FAIL],
    promise: request
  };
};

export const fetchInspectionsData = (ownerId, impersonation, url) => {
  const request = fetch('cica_inspections', ownerId, 'url', impersonation);// url ? fetch(url, 5000) : fetch(`cica_campaignleadses?$select=cica_name,cica_isactive,cica_campaign&$filter=cica_isactive ne false`, 5000);
  return {
    types: [FETCH_INSPECTION_DATA, FETCH_INSPECTION_DATA_SUCCESS, FETCH_INSPECTION_DATA_FAIL],
    promise: request
  }
};

export const fetchSystemSettings = () => {
  // const settingsURL = `cica_systemsettings?$select=cica_category, cica_description, cica_name`;
  const request = fetch('cica_systemsetting')// url ? fetch(url, 5000) : fetch(`cica_campaignleadses?$select=cica_name,cica_isactive,cica_campaign&$filter=cica_isactive ne false`, 5000);
  return {
    types: [FETCH_SYSTEM_SETTINGS_DATA, FETCH_SYSTEM_SETTINGS_DATA_SUCCESS, FETCH_SYSTEM_SETTINGS_DATA_FAIL],
    promise: request
  }
};

export const setOwnerId = (id, ownerGuid, value, ownerGuid1 ,name, marketOpen, marketCode, secondMarketValues) => (
  {
    type: SET_OWNER_ID,
    payload: {id, ownerGuid, value, ownerGuid1 ,name, marketOpen, marketCode, secondMarketValues}
  }
);

export const showLeads = () => (
  {
    type: SHOW_LEADS_DATA,
    payload: ''
  }
);

export const showInspections = () => (
  {
    type: SHOW_INSPECTIONS_DATA,
    payload: ''
  }
);

export const fetchCampaignData = (modelName, ownerId, source, impersonation) => {
  const request = fetch(modelName, ownerId, source, impersonation);// url ? fetch(url, 5000) : fetch(`cica_campaignleadses?$select=cica_name,cica_isactive,cica_campaign&$filter=cica_isactive ne false`, 5000);
  return {
    types: [FETCH_CAMPAIGN_DATA, FETCH_CAMPAIGN_DATA_SUCCESS, FETCH_CAMPAIGN_DATA_FAIL],
    promise: request
  }
};

export const fetchPolicyDataAssign = (modelName, personId, ownerId, source) => {
  const request = fetchPolicyInfo(modelName, personId, ownerId, source);
  return {
    types: [FETCH_POLICY_DATA, FETCH_POLICY_DATA_SUCCESS, FETCH_POLICY_DATA_FAIL],
    promise: request
  }
};


export const fetchOptionLeadType = () => (
  {
    types: [FETCH_OPTION_LEAD_TYPE, FETCH_OPTION_LEAD_TYPE_SUCCESS, FETCH_OPTION_LEAD_TYPE_FAIL],
    promise: fetch('cica_leadtype')
  }
);

export const fetchOptionLanguageIndicator = () => (
  {
    types: [FETCH_OPTION_LANG_INDICATOR, FETCH_OPTION_LANG_INDICATOR_SUCCESS,
      FETCH_OPTION_LANG_INDICATOR_FAIL],
    promise: fetch('cica_langindicator')
  }
);

export const fetchOptionDisposition = () => (
  {
    types: [FETCH_OPTION_DISPOSITION, FETCH_OPTION_DISPOSITION_SUCCESS,
      FETCH_OPTION_DISPOSITION_FAIL],
    promise: fetch('cica_leaddispositionstatus')
  }
);

export const fetchCallType = () => (
  {
    types: [FETCH_CALL_TYPE, FETCH_CALL_TYPE_SUCCESS,
      FETCH_CALL_TYPE_FAIL],
    promise: fetch('cica_calltype')
  }
);

export const updateUnassignedStartEndIndex = (startIndex, endIndex) => (
  {
    type: UNASSIGNED_START_END_INDEX,
    payload: { startIndex, endIndex }
  }
);

export const updateInspectedStartEndIndex = (startIndex, endIndex) => (
  {
    type: UPDATE_INSPECTED_START_END_INDEX,
    payload: { startIndex, endIndex }
  }
);

export const updateAssignedStartEndIndex = (startIndex, endIndex) => (
  {
    type: ASSIGNED_START_END_INDEX,
    payload: { startIndex, endIndex }
  }
);

export const updateActiveIndex = index => (
  {
    type: ACTIVE_INDEX,
    payload: parseInt(index, 10)
  }
);

export const updateSelectedRecords = (action, record) => {
  let type = '';
  if (action === 'addAll') {
    type = ADD_ALL;
  } else if (action === 'removeAll') {
    type = REMOVE_ALL;
  } else if (action === 'add') {
    type = ADD;
  } else if (action === 'remove') {
    type = REMOVE;
  }
  return {
    type,
    payload: record
  };
};

export const updateFilterExpanded = value => (
  {
    type: FILTER_EXPAND,
    payload: value
  }
);

export const updateInspectionFilterExpanded = value => (
  {
    type: INSPECTION_FILTER_EXPAND,
    payload: value
  }
);

export const updateFilter = (key, value) => {
  const obj = {};
  const request = new Promise((resolve, reject) => {
    obj[key] = value ? value.map(item => {
      if (item.label.indexOf('Warm') > -1) {
        return item.label.split(" ")[0];
      }
      return item.label;
    }) : [];
    if (!_.isEmpty(obj)) {
      resolve(obj);
    } else {
      reject('Error Mapping the values');
    }
  });
  return {
    types: [SET_FILTER_VALUE, SET_FILTER_VALUE_SUCCESS, SET_FILTER_VALUE_FAIL],
    promise: request
  };
};

export const applyFilter = () => {
  debug('APPLYING FILTER');
  return {
    type: APPLY_FILTER,
    payload: ''
  };
};

export const applyFilterIndex = (index) => {
  debug('APPLYING FILTER DIRECTLY USING INDEX');
  return {
    type: APPLY_FILTER_INDEX,
    payload: index
  };
};

export const reverseFilter = () => {
  debug('APPLYING REVERSE FILTER');
  return {
    type: REVERSE_FILTER,
    payload: ''
  };
};

export const clearFilter = () => (
  {
    type: CLEAR_ALL,
    payload: initialState.filter
  }
);

export const clearFilterIndex = (index) => {
  debug('CLEARING FILTER DIRECTLY USING INDEX');
  const initialFilter = initialState.filter;
  return {
    type: CLEAR_ALL_INDEX,
    payload: initialFilter[index]
  }
};

export const confirmAssignment = recordToUpdate => (
  {
    type: CONFIRM_ASSIGN,
    payload: recordToUpdate
  }
);

export const applyAssignment = () => (
  {
    type: APPLY_ASSIGNMENT,
    payload: ''
  }
);

export const fetchOwnerId = () => {
  const request = whoAmI();
  return {
    types: [FETCH_OWNER_ID, FETCH_OWNER_ID_SUCCESS, FETCH_OWNER_ID_FAIL],
    promise: request
  };
};

export const applySearchName = sortedData => (
  {
    type: APPLY_SEARCH_NAME,
    payload: sortedData
  }
);

export const applySearchStreet = sortedData => (
  {
    type: APPLY_SEARCH_STREET,
    payload: sortedData
  }
);

export const applySearchWritingAgent = sortedData => (
  {
    type: APPLY_SEARCH_WRITING_AGENT,
    payload: sortedData
  }
);

export const setProgressbarLabel = label => (
  {
    type: 'SET_PROGRESSBAR_LABEL',
    payload: label
  }
);

/*
  For the below actions the reducer is in app.js
*/
export const updateProgressBarMaxCount = (count, type) => {
  debug('updateProgressBarMaxCount', count);
  if (type === 'fetch') {
    return {
      type: 'FETCH_DATA_MAX_VALUE',
      payload: count
    };
  }

  return {
    type: 'ASSIGN_DATA_MAX_VALUE',
    payload: count
  };
};

export const updateProgressBarValue = (value, type) => {
  debug('updateProgressBarValue', value);
  if (type === 'fetch') {
    return {
      type: 'FETCH_DATA_VALUE',
      payload: value
    };
  }

  return {
    type: 'ASSIGN_DATA_VALUE',
    payload: value
  };
};

export const resetProgressBar = (type) => {
  if (type === 'fetch') {
    return {
      type: 'RESET_FETCH_PROGRESS_BAR',
      payload: ''
    };
  }

  return {
    type: 'RESET_ASSIGN_PROGRESS_BAR',
    payload: ''
  };
};

export const callLoadingScreen = () => {
  debug('CALLING LOADING SCREEN');
  return {
    type: 'SHOW_LOADING_SCREEN',
    payload: initialState.showAssignmentLoader
  };
};

export const resetState = () => (
  {
    type: RESET
  }
);

export const updateNameSearchParameter = (parameter, tab) => (
  {
    type: UPDATE_NAME_SEARCH,
    payload: {
      parameter,
      tab
    }
  }
);

export const updateStreetSearchParameter = (parameter, tab) => (
  {
    type: UPDATE_STREET_ADDRESS_SEARCH,
    payload: {
      parameter,
      tab
    }
  }
);

export const updateWritingAgentParameter = (parameter, tab) => (
  {
    type: UPDATE_WRITING_AGENT_SEARCH,
    payload: {
      parameter,
      tab
    }
  }
);

export const updateInspectionsData = (data) => (
  {
    type: UPDATE_INSPECTIONS_DATA,
    payload: data
  }
);

export const updateSelectedLanguage = currentLanguage => (
  {
    type: UPDATE_LANG,
    payload: currentLanguage
  }
);

export const updateActivePage = activePage => (
  {
    type: UPDATE_ACTIVE_PAGE,
    payload: activePage
  }
);




// WEBPACK FOOTER //
// ./src/state/modules/assign.js